<aside class="sidebar" [class.mobile-open]="isMobileOpen">
  <div class="logo-wrapper">
    <img src="/images/logowhite.png" alt="Logo" class="logo" />
    <button class="sidebar-close-btn" (click)="closeSidebar.emit()">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>

  <nav class="nav-menu">
    <a routerLink="/bank-detail" routerLinkActive="active" class="nav-item" (click)="onNavItemClick()">
      <i class="fa-solid fa-building-columns"></i> Bank Detail
    </a>

    <a routerLink="/product-list" routerLinkActive="active" class="nav-item" (click)="onNavItemClick()">
      <i class="fa-solid fa-box-open"></i> Product List
    </a>

    <a routerLink="/order-commission" routerLinkActive="active" class="nav-item" (click)="onNavItemClick()">
      <i class="fa-solid fa-hand-holding-dollar"></i> Order Commission
    </a>
  </nav>
</aside>
